import { render, staticRenderFns } from "./SharingStep.vue?vue&type=template&id=5cb2caef&"
import script from "./SharingStep.vue?vue&type=script&lang=js&"
export * from "./SharingStep.vue?vue&type=script&lang=js&"
import style0 from "./SharingStep.vue?vue&type=style&index=0&id=5cb2caef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports